import { Component, OnInit, Renderer2 } from "@angular/core";
import { NgbConfig } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "./models/user.service";

@Component({
  selector: "ab-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  public getexceptional: boolean;
  constructor(
    private ngbConfig: NgbConfig,
    private userService: UserService,
    private renderer: Renderer2,
  ) {
    this.ngbConfig.animation = false;
  }

  public ngOnInit() {
    // Add CSS class to HTML which trigger the new color modes
    this.userService.properties().subscribe((props: any) => {
      this.renderer.addClass(document.documentElement, props.color_mode);
    });
  }
}
